import type { ComponentProps } from 'react';
import { Image } from '../Image/Image';

type BrandCardImageProps = ComponentProps<typeof Image>;

export const BrandCardImage = ( { ...imgAttributes }: BrandCardImageProps ) => {

  return (
    <Image
      className={ 'brightness-90 group-hover:brightness-100 transition-all duration-200' }
      { ...imgAttributes } />
  )
}
BrandCardImage.displayName = 'BrandCardImage';
